var dtToday = new Date();
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    if(month < 10)
        month = '0' + month.toString();
    if(day < 10)
        day = '0' + day.toString();
    if(formatAMPM(new Date)>5){
    	day+=1;
    }
    var maxDate = year + '-' + month + '-' + day;
//     $('#cartDeliveryDate').attr('min', maxDate);
    
    function formatAMPM(date) {
    var hours = date.getHours();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var strTime = hours;
    return strTime;
  }

//         var datesToDisabled = ["19-10-2021","05-02-2021","23-03-2021","12-03-2021","29-03-2021","01-05-2021","14-05-2021","15-05-2021","16-05-2021","21-07-2021","22-07-2021","23-07-2021","14-08-2021","18-07-2021","19-07-2021","25-12-2021","26-12-2021","05-02-2022","23-03-2022","12-03-2022","29-03-2022","01-05-2022","14-05-2022","15-05-2022","16-05-2022","21-07-2022","22-07-2022","23-07-2022","14-08-2022","18-07-2022","19-07-2022","25-12-2022","26-12-2022","05-02-2023","23-03-2023","12-03-2023","29-03-2023","01-05-2023","14-05-2023","15-05-2023","16-05-2023","21-07-2023","22-07-2023","23-07-2023","14-08-2023","18-07-2023","19-07-2023","25-12-2023","26-12-2023","05-02-2024","23-03-2024","12-03-2024","29-03-2024","01-05-2024","14-05-2024","15-05-2024","16-05-2024","21-07-2024","22-07-2024","23-07-2024","14-08-2024","18-07-2024","19-07-2024","25-12-2024","26-12-2024","05-02-2025","23-03-2025","12-03-2025","29-03-2025","01-05-2025","14-05-2025","15-05-2025","16-05-2025","21-07-2025","22-07-2025","23-07-2025","14-08-2025","18-07-2025","19-07-2025","25-12-2025","26-12-2025"];
        var dateToday = new Date();

       // ----- check if time is 8 or above

        var currentHours = dateToday.getHours();
        var currentMinutes = dateToday.getMinutes();
        var disableCurrentDate = currentHours > 18 || (currentHours === 18 && currentMinutes >= 00);

      // ------


   $('.cartDeliveryDates').datepicker({
      minDate: new Date(dateToday),
       beforeShowDay: function(date){
         var string = jQuery.datepicker.formatDate('dd-mm-yy', date);
         
         // return [ datesToDisabled.indexOf(string) == -1 ]

         // Check if the date is in the manually disabled dates array
         
         let newDatesToDisable=document.querySelector('#datesToDisable').innerText;
		 let stripedDates=newDatesToDisable.trim();
		
		 let datesToDisabled=stripedDates.split(',');


         // Check if the date is in the manually enabled dates array

        let newDatesToEnable=document.querySelector('#datesToEnable').innerText;
		let stripedDatesEnable=newDatesToEnable.trim();
        var datesToEnable = stripedDatesEnable.split(',');
        var isManuallyEnabled = datesToEnable.indexOf(string) !== -1;
        if (isManuallyEnabled) {
            return [true, "", "This date is manually enabled"];
        }
         
         // Check if the date is Sunday
        var isSunday = date.getDay() === 0;
        if (isSunday) {
            return [false, "", "Sundays are disabled"];
        }

        // Check if the date is the first date (minDate)
        // var isFirstDate = date.getTime() === dateToday.getTime();
        // if (isFirstDate) {
        //     return [false, "", "First date is not selectable"];
        // }

        // // Check if the date is the 1st of the month
        // var isFirstOfMonth = date.getDate() === 1; 
        // if (isFirstOfMonth) {
        //     return [false, "", "First day of the month is not selectable"];
        // }

        var formattedToday = dateToday.getFullYear() + '-' + (dateToday.getMonth() + 1) + '-' + dateToday.getDate();
        var formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        if (formattedToday === formattedDate && disableCurrentDate) {
            return [false, "", "Current date is disabled after 6 PM"];
        }         

        // Check if the date is in the disabled dates array
        var isDisabledDate = datesToDisabled.indexOf(string) !== -1;
        if (isDisabledDate) {
            return [false, "", "This date is not selectable"];
        }

         return [true, ""];
       }
    });
	